var definitionList = 'fx_c76f37be_14nggi00';

export { definitionList };
//# sourceMappingURL=definitionList.vanilla.mjs.map
